export class LoadExploreGroupsAction {
  static readonly type = '[ExploreGroups] ExploreGroupsAction';

  constructor(
    public payload: {
      notJoined?: boolean;
      notFromMe?: boolean;
    } = {},
  ) {}
}
